import React, { useMemo } from 'react';
import styled from 'styled-components';

import Checkbox from 'antd/es/checkbox';

const DayPicker = ({ value = [], disabled = [], ...rest }) => {
  const options = useMemo(() => {
    return [
      { label: 'Mon', value: 1 },
      { label: 'Tue', value: 2 },
      { label: 'Wed', value: 3 },
      { label: 'Thu', value: 4 },
      { label: 'Fri', value: 5 },
      { label: 'Sat', value: 6 },
      { label: 'Sun', value: 7 },
    ].map(o => {
      o.disabled = disabled.includes(o.value) && !value.includes(o.value);
      return o;
    });
  }, [disabled, value]);

  return (
    <DayOptionsWrapper
      {...rest}
      gutter={8}
      options={options}
      value={value}
    />
  );
};

const DayOptionsWrapper = styled(Checkbox.Group)`
  & .ant-checkbox {
    display: none;
  }

  & .ant-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 39px;
    border-radius: 20px;
    border-width: 1px;
    border-style: solid;
    border-color: #EFF2F5;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    user-select: none;
    background: #fff;
    color: #42B0D5;
    transition: all 300ms;
    margin-bottom: 6px;
  }

  & .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
    background: #42B0D5;
    color: #fff;
    border-color: transparent;
    transition: all 300ms;
  }
`;

export default DayPicker;
